import CopyRight from './container/index';

export default CopyRight;



// WEBPACK FOOTER //
// ./src/components/page/CopyRight/index.js